import { Component, input, output } from '@angular/core';
import { AixCheckboxPanelComponent, AixDataTestingDirective } from '@trade-platform/ui-components';
import { ProductsFilterType } from '../../store/product/actions';

@Component({
    selector: 'aix-filter-sidebar',
    templateUrl: './filter-sidebar.component.html',
    styleUrls: ['./filter-sidebar.component.scss'],
    standalone: true,
    imports: [AixDataTestingDirective, AixCheckboxPanelComponent]
})
export class AixFilterSidebarComponent {
    activeFilter = input<any>();
    queues = input<any>();
    numberShowList = input<number>(7);

    removeFilters = output();
    selectFilter = output<{ filter: any; key: ProductsFilterType }>();

    selectAllProducts() {
        this.removeFilters.emit();
    }

    setFilter(event: any, keySelect: ProductsFilterType) {
        this.selectFilter.emit({ filter: event, key: keySelect });
    }
}
